import { APPOINTMENTS_BASE_URL } from '../environment';
import HttpRequest from '../request';
import { JoinMeetingAsParticipantResponse, MeetingInformation } from './types';

class AppointmentsServiceClient extends HttpRequest {
  public async getMeetingInformation(token: string) {
    const response = await this.get<MeetingInformation>({
      url: '/meetings/information',
      params: { token },
    });
    return response;
  }

  public async joinMeetingAsParticipant(token: string) {
    const response = await this.post<JoinMeetingAsParticipantResponse>({
      url: '/meetings/join',
      payload: { token },
    });
    return response;
  }
}

const appointmentsServiceClient = new AppointmentsServiceClient(APPOINTMENTS_BASE_URL);

export default appointmentsServiceClient;
